<template>
  <div
    class="
      col-sm-10
      offset-sm-2
      col-md-8
      offset-md-2
      col-lg-8
      offset-lg-2
      text-center
    "
  >
    <div class="text-left">
      <b-button pill href="/" size="md" class="" variant="light"
        ><font-awesome-icon :icon="['fa', 'arrow-left']"
      /></b-button>
    </div>
    <b-card bg-variant="white" text-variant="dark">
      <center>
        <img
          src="/static/LogoCompleto_Vertical_Gris_Vectorial.png"
          width="60%"
          class="img-responsive"
          alt="Hotel de l'Isard"
        />
      </center>
      <hr class="mt-4 mx-3" />
      <p class="card-text pt-2 mx-3" v-html="$i18n.t('login.termsContent')">
        <!-- {{ $i18n.t('termsContent') }} -->
      </p>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "Terms",
  data() {
    return {};
  },
  mounted() {
    if (localStorage.getItem("locale")) {
      this.$root.$i18n.locale = localStorage.getItem("locale");
    }
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #7a7a7a;
}
</style>



// WEBPACK FOOTER //
// src/components/Terms.vue